export default __webpack_public_path__ + "static/img5-f668d642259dde9a60f26e995fff6499.jpg";